import { createElement, type ComponentType, type PropsWithChildren, type ReactNode } from "react";

export const WRITER_MOBILE_CONTENT_PATHS = ["/writer"] as const;

export function isAllowedMobileContentPath(
  pathname: string,
  allowedPaths: readonly string[],
) {
  return allowedPaths.some((allowedPath) => (
    pathname === allowedPath || pathname.startsWith(`${allowedPath}/`)
  ));
}

type MobileContentGateProps = PropsWithChildren<{
  allowedPaths: readonly string[];
  isMobile: boolean;
  MobileSideComponent: ComponentType;
  pathname: string;
}>;

export function MobileContentGate({
  allowedPaths,
  children,
  isMobile,
  MobileSideComponent,
  pathname,
}: MobileContentGateProps): ReactNode {
  if (!isMobile || isAllowedMobileContentPath(pathname, allowedPaths)) {
    return children ?? null;
  }

  const mobileSide = createElement(MobileSideComponent);
  if (children) return mobileSide;

  return createElement(
    "div",
    { className: "fixed inset-0 z-[999] bg-background" },
    mobileSide,
  );
}
